<div class="title">FORGOT YOUR PASSWORD?</div>
<div class="sub-title">Enter the email address associated with your Hubtiger account and we'll send you a reset password
    link
</div>
<div class="margin-top-32">
    <div>
    <span class="p-float-label">
      <input pInputText type="text" id="email" name="email" class="username" [(ngModel)]="form.email"/>
      <label for="email">Email</label>
    </span>
        <div>
            <button type="submit" class="btn btn-primary" (click)="reset()" [disabled]="busyResetting"><i
                    class="fa fa-spin fa-spinner" *ngIf="busyResetting"></i><span *ngIf="!busyResetting">Request Reset Link</span>
            </button>
        </div>
        <div class="margin-top-32" style="text-align: center;">
            <a routerLink="/" class="forgotpassword">Return to Login</a>
        </div>
    </div>
</div>
<div class="error" *ngIf="error">
    <span>{{errorMessage}}</span>
</div>
